import React, { Component } from "react";
import { BASE_API_URL } from "../../services/apiService";

export default class Heading extends Component {
  constructor(props) {
    super(props);

    this.state = {
      type: "all",
      trailTimeCount: [],
    };
    this.entityType = this.entityType.bind(this);
  }

  componentDidMount() {
    fetch(`${BASE_API_URL}entity/trailTimeCount?type=Timeline`)
      .then((res) => res.json())
      .then((json) => {
        if (json) {
          this.setState({
            trailTimeCount: Object.keys(json),
          });
        } else {
          this.setState({
            trailTimeCount: [],
          });
        }
      });
  }
  entityType(ev) {
    this.setState({ type: ev.target.value });
    var url = "";
    url = ev.target.value
      ? `/search/timelines?type=${ev.target.value}`
      : `/search/timelines`;
    window.location.href = url; //`/search/timelines?type=${ev.target.value}`;
  }
  render() {
    var items = this.props.Data;
    var type = this.props.Data2;
    var entity = this.props.Entity;
    return (
      <div>
        <div id="header">
          <h1 class="header-h1" justify-content="center">
            All Timelines
          </h1>
          <div class="sub-title">
            Trace historic change across themes curated by experts
          </div>
          <div id="filters2">
            <div id="search-result-count">{items.length} Items</div>
            <div class="filter-inputs-wrapper">
              <div class="filter-select">
                <div class="filter-label">Filter by</div>
                <select
                  class="library-select"
                  onChange={this.entityType}
                  value={entity ? entity : this.state.type}
                >
                  <option value="">All</option>
                  {type.map(
                    (entity) =>
                      this.state.trailTimeCount.includes(entity.id) && (
                        <option value={entity.id}>{entity.name}</option>
                      )
                  )}
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
